import React from "react";
import ProductInfoPanelComponent from "./productInfoPanel.component";
import { connect, useSelector } from "react-redux";
import {
  updateProductInfo,
  updateProductPhoto,
} from "modules/product-mgmt/redux/action/products.action";
import { selectLoading } from "modules/notification";
import { unwrapResult } from "@reduxjs/toolkit";
import {AccessRights} from "lib/constants/accessRights";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import { setProductPicture } from "../../../redux/slice/productPage.slice";

function ProductInfoPanelContainer({
  isSaving,
  isEditing,
  setIsEditing,
  updateProductInfo,
  updateProductPhoto,
  createdAt,
  updatedAt,
  newPicturePending,
  setNewPicturePending,
  newUploadPicture,
  setNewUploadPicture,
  setProductPicture,
}) {
  const hasProductEditAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.LISTING_UPDATE));
  const lang = useSelector(state => state.constant.languages);
  const language = useSelector(state => state.profile.language);

  const handleEdit = (value) => {
    setIsEditing(value);
  };

  const handleCancel = (formik) => {
    formik.resetForm();
    setIsEditing(false);
    setNewPicturePending(false);
    setNewUploadPicture("");
  };

  const handleSaveChanges = () => {
    updateProductInfo()
      .then(unwrapResult)
      .then(() => {
        setIsEditing(false);
      });

    if (newPicturePending) {
      const base64Image = newUploadPicture;
      setProductPicture(base64Image);
      updateProductPhoto(base64Image);
      setNewUploadPicture("");
      setNewPicturePending(false);
    }
  };

  return (
    <ProductInfoPanelComponent
      hasProductEditAccessRight={hasProductEditAccessRight}
      isEditing={isEditing}
      handleEdit={handleEdit}
      handleCancel={handleCancel}
      handleSaveChanges={handleSaveChanges}
      isSaving={isSaving}
      createdAt={createdAt}
      updatedAt={updatedAt}
      language={language}
      lang={lang}
      newPicturePending={newPicturePending}
    />
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateProductInfo: () => dispatch(updateProductInfo()),
  updateProductPhoto: (payload) => dispatch(updateProductPhoto(payload)),
  setProductPicture: (payload) => dispatch(setProductPicture(payload)),
});

const mapStateToProps = (state) => ({
  isSaving: selectLoading(state, updateProductInfo.typePrefix),
  createdAt: state.productPage.createdAt,
  updatedAt: state.productPage.updatedAt,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductInfoPanelContainer);
